<template>
  <div class="container article-main-container" v-bind:style="'direction:' + direction">
    <h2>{{article.title}}</h2>
    <div v-html="article.description"></div>
  </div>
</template>

<script>
  import { getDataFromServer } from '../utils/DataProvider'
  export default {
    data: () => {
      return{
        article: {},
        direction: '',
      }
    },
    methods: {
        getArticle(){
          getDataFromServer('get_article_byid', {id: this.$route.params.article_id})
          .then(obj => {           
            if(obj.data.success === true){
              this.article = obj.data.data
              console.log("article lang: ", this.article.language)
              if(this.$store.getters.CURRENT_LANGUAGE !== this.article.language){
                this.$store.dispatch('SET_CURRENT_LANGUAGE', this.article.language)
              }
              this.direction = this.$store.getters.CURRENT_LANGUAGE === 'he_IL' ? 'rtl':'ltr';

            }
            else{
              this.flash('get articles error: ' + obj.data.text , 'error', {timeout: 5000})
            }          
          })
          .catch(err => { 
            this.flash('get articles error: ' + obj.data.text , 'error', {timeout: 5000})
          })
        }
    },
    created(){
      console.log("created article", this.$route.params.article_id)      
      this.getArticle();
    },
    watch: {
      '$route' (to, from){        
        if(this.$route.params.article_id !== this.article._id){
          this.getArticle();
        }
      }
    }
  }
</script>

<style>
    .article-main-container{
        margin-top: 150px;
        background-color: #fff;
        border-radius: 6px;
        padding: 60px 20px;
        margin-bottom: 30px;
    }

    .article-main-container h2{
      text-align: center;
      font-size: 18px;
      margin-bottom: unset !important;
      padding-bottom: unset !important;
    }

    .article-main-container img{
      max-width: 1130px !important;
    }
    
    @media screen and (max-width: 767px){
      .article-main-container{
        padding: 0;
        margin-top: 90px;
        background-size: cover; 
      }
    }

</style>